import { render, staticRenderFns } from "./modal-edittags.vue?vue&type=template&id=099ff412&scoped=true&"
import script from "./modal-edittags.vue?vue&type=script&lang=js&"
export * from "./modal-edittags.vue?vue&type=script&lang=js&"
import style0 from "./modal-edittags.vue?vue&type=style&index=0&id=099ff412&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099ff412",
  null
  
)

export default component.exports